import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDatePickerProps,
} from "@material-ui/pickers";
import ptBR from "date-fns/locale/pt-BR";
import { Controller } from "react-hook-form";
import { useFormContext } from "components/Form";

interface DatePickerProps
  extends Omit<KeyboardDatePickerProps, "value" | "onChange"> {
  name: string;
  customLabel?: string;
}

export function DatePicker({
  variant = "inline",
  inputVariant = "outlined",
  format = "dd/MM/yyyy",
  customLabel,
  name,
  ...rest
}: DatePickerProps) {
  const {
    methodsForm: { control, trigger },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => {
        const { ref, value, onChange, ...fieldProps } = field;
        return (
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <label>
              {customLabel}

              <KeyboardDatePicker
                {...rest}
                variant={variant}
                inputVariant={inputVariant}
                format={format}
                value={value || null}
                onChange={(dateValue) => {
                  setTimeout(() => {
                    trigger(name);
                  }, 0);
                  onChange(dateValue);
                }}
                inputRef={ref}
                {...fieldProps}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                type="tel"
              />
            </label>
          </MuiPickersUtilsProvider>
        );
      }}
    />
  );
}
